import React from 'react';
import { useFormContext } from '../context/FormContext';
import Button from '../../Button/Button';
import { useTranslation } from "react-i18next";


/**
 * SubmitButton - Context-aware submit button
 * @param {Object} props
 * @param {string} props.children - Button text
 */
export const SubmitButton = ({ children, ...props }) => {
    const { isSubmitting, errors, submitAttempted, fieldLabels } = useFormContext();

    const { t } = useTranslation();



    // Get list of missing fields
    const missingFields = Object.keys(errors).map(field => {
        return fieldLabels[field] || field
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase());
    });

    return (
        <div className="w-full flex flex-col">
            <Button
                type="submit"
                loading={isSubmitting}
                disabled={isSubmitting}
                {...props}
            >
                {children}
            </Button>
            {submitAttempted && missingFields.length > 0 && (
                <div className="mt-2 text-red-500 text-sm text-center animate-in fade-in slide-in-from-top-1">
                    {missingFields.join(', ')} {t('common.areRequired')}
                </div>
            )}
        </div>
    );
};

export default SubmitButton;
